import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BlogBlockButton } from '../blog.models';

@Component({
  selector: 'app-blog-block-button',
  templateUrl: './block-button.component.html',
  styleUrls: ['./block-button.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogBlockButtonComponent {
  @Input({ required: true }) block!: BlogBlockButton;

  get target(): string | null {
    return this.block?.target === '_blank' ? '_blank' : null;
  }

  get rel(): string | null {
    return this.target ? 'noopener noreferrer' : null;
  }

  get classes(): string[] {
    return [
      'apple-cta',
      this.block?.variant === 'secondary' ? '' : 'apple-cta--blue',
    ].filter(Boolean);
  }
}
